import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { getUser } from '~features/user/ducks';

const useUserOrganizationAsDefault = ({ organizations, change }) => {
  const user = useSelector(state => getUser(state));
  const userOrganizationId = user?.ordererOrganization.id;

  useEffect(() => {
    if (!userOrganizationId || organizations?.length === 0) return;
    // Look for the user organization in the supplied organization list
    // which may or may not include it
    const organization = organizations.find(
      organization => organization.value === userOrganizationId
    );

    if (organization) {
      // If the user organization is found, set it as the default
      change(organization);
    }
  }, [organizations, userOrganizationId]);
};

export default useUserOrganizationAsDefault;
